import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import type { Query } from '@tanstack/react-query';
import { del, get, set } from 'idb-keyval';

import { RESEARCH_QUERY_CACHE_TTL_MS } from '../features/research/shared/cache/constants';

const PERSIST_KEY = 'react-query-cache';

export const QUERY_PERSIST_BUSTER = 'spectral-workspace-cache-v2';
export const QUERY_PERSIST_MAX_AGE = RESEARCH_QUERY_CACHE_TTL_MS;

const PERSISTABLE_QUERY_PREFIXES = new Set([
  'session-groups',
  'session-group',
  'research-configurations-lite',
]);

const isPersistableQuery = (query: Query) => {
  const key = query.queryKey[0];
  return typeof key === 'string' && PERSISTABLE_QUERY_PREFIXES.has(key);
};

const idbStorage = {
  getItem: async (key: string) => (await get(key)) ?? null,
  setItem: async (key: string, value: string) => {
    await set(key, value);
  },
  removeItem: async (key: string) => {
    await del(key);
  },
};

export const queryPersister = createAsyncStoragePersister({
  storage: idbStorage,
  key: PERSIST_KEY,
});

export const queryPersistOptions = {
  persister: queryPersister,
  buster: QUERY_PERSIST_BUSTER,
  maxAge: QUERY_PERSIST_MAX_AGE,
  dehydrateOptions: {
    shouldDehydrateQuery: (query: Query) =>
      query.state.status === 'success' && isPersistableQuery(query),
  },
} as const;
